import { v4 as uuidv4 } from 'uuid';
import {action, computed, observable} from "mobx";

export interface INotification {
  dismissed:boolean;
  dismissedDate:Date;
  displayEndDate:Date;
  displayStartDate: Date;
  solutionId:string;
  bundleId:string;
  postId:string;
  title:string;
  message:string;
  type:string;
  userId:string;
  icon:string;
  _id:string;
  referencedEntityName:string;
  referencedEntityId:string;
}


interface INotificationType {
  type: string;
  plural: string;
  icon: string;
}
type NotificationTypeKeys = "MENTION" | "REPLY" | "UNKNOWN";
type NotificationTypeMap = Record<NotificationTypeKeys, INotificationType>;
interface INotificationTypeHelper {
  notificationTypes:NotificationTypeMap;
  isMention:(notification:INotification)=>boolean;
  isReply:(notification:INotification)=>boolean;
  isMentionOrReply:(notification:INotification)=>boolean;
  notificationTypeForString:(type:string)=>INotificationType;
  containsMentionsOrReplies:(collapsedNotification:CollapsedNotification)=>boolean;
}

export const NotificationTypeHelper:INotificationTypeHelper = {
  notificationTypes:{
    MENTION:{type:'mention', plural:'mentions', icon:'alternate_email'},
    REPLY:{type:'reply', plural:'replies', icon:'reply'},
    UNKNOWN:{type:'unknown', plural:'unknowns', icon:''},
  },
  containsMentionsOrReplies(collapsedNotification:CollapsedNotification) {

    for(let i=0;i<collapsedNotification.notificationsByTypeArray.length;i++) {
      if(collapsedNotification.notificationsByTypeArray[i].type===NotificationTypeHelper.notificationTypes.MENTION.type
        || collapsedNotification.notificationsByTypeArray[i].type===NotificationTypeHelper.notificationTypes.REPLY.type) {
        return true;
      }
    }
    return false;
  },
  isMention(notification:INotification) {
    return notification.type == NotificationTypeHelper.notificationTypes.MENTION.type;
  },
  isReply(notification:INotification) {
    return notification.type == NotificationTypeHelper.notificationTypes.REPLY.type;
  },
  isMentionOrReply(notification:INotification) {
    return notification.type == NotificationTypeHelper.notificationTypes.MENTION.type || notification.type == NotificationTypeHelper.notificationTypes.REPLY.type;
  },
  notificationTypeForString(type:string):INotificationType {
    if(type) {
      const keys = Object.keys(NotificationTypeHelper.notificationTypes);
      for(let i=0;i<keys.length;i++) {
        const notificationType = NotificationTypeHelper.notificationTypes[keys[i]];
        if(notificationType.type===type) {
          return notificationType;
        }
      }


    }
    return NotificationTypeHelper.notificationTypes.UNKNOWN;
  }
}




export class CollapsedNotification {
  id:string;
  solutionId:string;
  bundleId:string;
  postId:string;
  title:string;
  notificationsByTypeArray:INotificationsByType[] = [];
  displayStartDate: Date;
  @observable private _notificationLinkUsed:boolean = false;

  constructor(notification:INotification) {
    this.id = uuidv4();
    this.solutionId = notification.solutionId;
    this.bundleId = notification.bundleId;
    this.postId = notification.postId;
    this.title = notification.title;
    this.displayStartDate = notification.displayStartDate;
    this.addNotification(notification);
  }

  @action markNotificationLinkUsed() {
    this._notificationLinkUsed = true;
  }

  @computed get notificationLinkUsed() {
    return this._notificationLinkUsed;
  }

  addNotification(notification:INotification) {

    // for sorting
    if(notification.displayStartDate>this.displayStartDate) {
      this.displayStartDate = notification.displayStartDate;
    }

    if(this.notificationsByTypeArray.length != 0) {
      for(const notificationsByType of this.notificationsByTypeArray) {
        if(notificationsByType.type == notification.type) {
          notificationsByType.notifications.push(notification);
          return;
        }
      }
    }
    this.notificationsByTypeArray.push({type:notification.type, notifications:[notification]});
  }

  matches(notification:INotification) {
    return this.solutionId == notification.solutionId && this.bundleId == notification.bundleId && this.postId == notification.postId;
  }

  notificationIds() {
    const notificationIds:string[] = [];
    for(const notificationsByType of this.notificationsByTypeArray) {
      if(notificationsByType.notifications) {
        notificationIds.push(...notificationsByType.notifications.map(n=>n._id));
      }
    }
    return notificationIds; //this.notificationsByTypeArray.map(ntb=>ntb.notifications.map(n=>n._id));
  }

  referencedEntityIds() {
    const referencedEntityIds:string[] = [];
    for(const notificationsByType of this.notificationsByTypeArray) {
      if(notificationsByType.notifications) {
        referencedEntityIds.push(...notificationsByType.notifications.map(n=>n.referencedEntityId));
      }
    }
    return referencedEntityIds;
  }

  allNotifications() {
    const allNotifications:INotification[] = [];
    for(const notificationsByType of this.notificationsByTypeArray) {
      if(notificationsByType.notifications) {
        allNotifications.push(...notificationsByType.notifications);
      }
    }
    return allNotifications;
  }

}

export interface INotificationsByType {
  type:string;
  notifications:INotification[];
}